/**
 * API Configuration Utility
 * Dynamically determines the correct API base URL based on the current environment
 */

/**
 * Get the base URL for API calls
 * @returns {string} The base URL for API endpoints
 */
export const getApiBaseUrl = () => {
  const { protocol, hostname, port } = window.location;
  
  // If accessing via ngrok or other proxy (no port in URL), don't add :8080
  // ngrok URLs look like: https://abc123.ngrok.io (no port)
  // localhost looks like: http://localhost:3000 or served from :8080
  if (hostname.includes('ngrok')) {
    // Use current origin without adding port
    return `${protocol}//${hostname}`;
  }
  
  
  if (hostname.includes('innovationworks')) {
    return `${protocol}//innovationworks.com:49080`;
  }

  // For localhost development (React runs on 3000, backend on 8080)
  return `${protocol}//${hostname}:49080`;
};

/**
 * Make a fetch request to an API endpoint with the correct base URL
 * @param {string} endpoint - The API endpoint (e.g., '/api/disability-profiles')
 * @param {RequestInit} options - Fetch options
 * @returns {Promise<Response>} The fetch response
 */
export const apiFetch = async (endpoint, options = {}) => {
  const baseUrl = getApiBaseUrl();
  const url = endpoint.startsWith('/') ? `${baseUrl}${endpoint}` : `${baseUrl}/${endpoint}`;
  
  // Debug logging
  console.log(`🌐 API Request: ${url}`);
  
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });
};

export const apiPost = async (endpoint, data, options = {}) => {
  const baseUrl = getApiBaseUrl();
  const url = endpoint.startsWith('/') ? `${baseUrl}${endpoint}` : `${baseUrl}/${endpoint}`;

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    body: JSON.stringify(data),
    ...options,
  });
};